import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { PairDeviceDto } from '@/types/dtos/player/request/pair-device.dto.ts';
import type { PairDeviceResponseDto } from '@/types/dtos/player/response/pair-device.dto.ts';
import { GET_PLAYERS_QUERY_KEY } from '@/state/queries/players/use-get-players';
import { GET_AV_SOURCES_QUERY_KEY } from '@/state/queries/players/use-get-av-sources';
import { GET_SPACE_PLAYER_SETUP_QUERY_KEY } from '@/state/queries/players/use-get-space-player-setup';

export const usePairDeviceMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: PairDeviceDto) => {
      const token = await getToken();
      return pairDevice(params, token ?? '');
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_PLAYERS_QUERY_KEY],
      });
      queryClient.invalidateQueries({ queryKey: [GET_AV_SOURCES_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [GET_SPACE_PLAYER_SETUP_QUERY_KEY] });
    },
  });
};

const pairDevice = async (params: PairDeviceDto, token: string): Promise<PairDeviceResponseDto> => {
  const url = `${import.meta.env.VITE_API_URL}/player/pair-device`;
  return sendJSONRequest({ url, method: METHOD.POST, body: params, token });
};
